import { createSelector } from 'reselect'
import type { AppStateType } from '../../../reducers/appstate'
import type { UserType } from '../../../flowTypes'

export const isChurned = (state: AppStateType): boolean => state && state.user && !!state.user.churned

export const isUserExpiring = (state: AppStateType): boolean => state.userLoaded && !!state.user.isSubscribed && !!state.user.subscription_expires_at && state.user.subscription_expires_at < Date.now() + 14 * 24 * 60 * 60 * 1000

export const userLoaded = (state: AppStateType): boolean => state.userLoaded

export const user = (state: AppStateType): UserType => state.user

export const isSubscribed: (state: AppStateType) => boolean = createSelector(
  [userLoaded, user],
  (isUserLoaded: boolean, userObj: UserType): boolean => {
    return isUserLoaded && !!userObj.isSubscribed
  }
)

export const paywallHeaderText: (state: AppStateType) => string = createSelector(
  [isUserExpiring, isChurned],
  (isExpiring: boolean, churned: boolean): string => {
    let headerText = `Connect with your\nsexual self`
    if (isExpiring) {
      headerText = 'Renew today to keep listening'
    } else if (churned) {
      headerText = 'Keep your subscription'
    }
    return headerText
  }
)

export const paywallSubHeaderText: (state: AppStateType) => string | null | undefined = createSelector(
  [isUserExpiring, isChurned],
  (isExpiring: boolean, churned: boolean): string | null | undefined => {
    let headerText
    if (isExpiring) {
      headerText = 'Your access to Dipsea Unlimited will expire soon'
    } else if (churned) {
      headerText = `Your new subscription settings\nwill apply starting today`
    }
    return headerText
  }
)
